<template>
  <md-list>
    <draggable v-model="strategiesList" v-on:change="changeList">
      <md-list-item
        v-for="(strategy, index) in strategiesList"
        :key="index"
        :class="{
          active: index === selectedIndex,
          innactive: !strategy.enabled,
          overriden: strategy.overriden,
        }"
        @click="select(index)"
      >
        <span class="strategy-name md-list-item-text">{{ strategy.name }}</span>
        <div>
          <md-button class="md-icon-button md-list-action md-white" @click.stop="duplicateItem(index)">
            <md-icon>content_copy</md-icon>
            <md-tooltip md-direction="top">Duplicate item</md-tooltip>
          </md-button>

          <md-button
            v-if="isMultipleDuplicationEnabled(index)"
            class="md-icon-button md-list-action md-white"
            @click.stop="toggleModal(index)"
          >
            <md-tooltip md-direction="top">Advanced duplication</md-tooltip>
            <md-icon>reply_all</md-icon>
          </md-button>
        </div>
      </md-list-item>
    </draggable>
  </md-list>
</template>

<script>
import clone from 'lodash/cloneDeep'
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  name: 'StrategiesList',
  props: {
    endpoints: Object,
    newItemName: String,
    itemType: String,
    hotels: Array,
  },
  components: {
    draggable,
  },
  methods: {
    toggleModal(index) {
      this.$emit('toggleModal', index)
    },
    update(newData) {
      Vue.set(this.strategiesList, this.selectedIndex, newData)
    },
    deleteSelected() {
      this.strategiesList.splice(this.selectedIndex, 1)
      this.select(Math.max(this.selectedIndex - 1, 0))
    },
    add() {
      if (this.itemType === 'Pax Grid') {
        this.strategiesList.push(
          Object.assign({
            name: this.newItemName,
            id: 0,
            enabled: true,
            order: 0,
            travel_windows: [
              {
                key: this.moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                value: this.moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
              },
            ],
            anticipation_days_from: 0,
            anticipation_days_to: 0,
            pax_grid_type: 'FULL',
            pax_grid_price_type: 'ROOM',
            channels_online: true,
            default_pax_grid_amount_type: 'PERCENTAGE',
            room_type_ids: [],
            booking_windows: [],
          })
        )
      } else {
        this.strategiesList.push(
          Object.assign(
            {
              name: this.newItemName,
              id: 0,
              enabled: true,
              order: 0,
              travel_windows: [
                {
                  key: this.moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                  value: this.moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                },
              ],
              anticipation_days_from: 0,
              anticipation_days_to: 0,
              room_type_ids: [],
              booking_windows: [{ key: null, value: null }],
            },
            this.endpoints.create()
          )
        )
      }

      this.select(this.strategiesList.length - 1)
    },
    select(index) {
      if (index === false) this.selectedIndex = null
      else {
        this.selectedIndex = index
        this.activeStrategy = this.strategiesList[this.selectedIndex]

        this.$emit('select', this.activeStrategy)
      }
    },
    duplicateItem(index) {
      const actualElement = this.actualElement(index)
      let duplicate
      if (!this.isItemSaved(actualElement)) {
        duplicate = clone(this.strategiesList[index])
        duplicate.name = 'Duplicate of ' + duplicate.name
        this.strategiesList.push(duplicate)
        this.select(this.strategiesList.length - 1)
      } else {
        this.endpoints.get(this.$root.hotelId, actualElement.id, (error, data) => {
          duplicate = data
          duplicate.id = null
          duplicate.name = 'Duplicate of ' + duplicate.name
          this.strategiesList.push(duplicate)
          this.select(this.strategiesList.length - 1)
        })
      }
    },
    async duplicateToOtherHotels(hotelIds, index) {
      const actualElement = this.actualElement(index)

      const destinationHotelsDTO = {
        hotel_ids: hotelIds,
      }

      this.endpoints.duplicate(this.$root.hotelId, actualElement.id, destinationHotelsDTO, (error, data) => {
        if (error) return this.displayDuplicationAlert(true)

        this.displayDuplicationAlert()
      })
    },
    displayDuplicationAlert(error) {
      this.$notify({
        timeout: 8000,
        message: error ? 'Error duplicating item' : 'Item duplicated',
        icon: error ? 'error' : 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: error ? 'danger' : 'success',
      })

      return error
    },
    actualElement(index) {
      return this.strategiesList[index]
    },
    isItemSaved(actualElement) {
      return actualElement.id
    },
    isMultipleDuplicationEnabled(index) {
      const actualElement = this.actualElement(index)
      return this.isItemSaved(actualElement) && this.hotels.length > 0
    },
    changeList(change) {
      this.selectedIndex = change.moved.newIndex
      this.$emit('change', this.strategiesList)
    },
    retrieveStrategies(selectedIdx) {
      if (typeof selectedIdx === 'undefined') selectedIdx = this.selectedIndex

      this.endpoints.list(this.$root.hotelId, (error, response) => {
        this.strategiesList.splice(0, this.strategiesList.length, ...response)

        if (this.strategiesList.length) this.select(selectedIdx)
      })
    },
  },
  data() {
    return {
      strategiesList: [],
      activeStrategy: null,
      selectedIndex: null,
    }
  },
  created() {
    this.retrieveStrategies(0)
  },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/md/_variables.scss';
.innactive button {
  color: var(--md-theme-default-disabled-on-background, rgba(0, 0, 0, 0.26)) !important;
}
.strategy-name {
  position: relative;
  display: block;
  text-overflow: ellipsis;
}
</style>
